module.exports = global.config = {
    isPolice: false,
    puuid: ""
    // other global config variables you wish
};